import type {
	PersistedClient,
	Persister,
} from "@tanstack/react-query-persist-client";
import { del, get, set } from "idb-keyval";

const CACHE_KEY = "ruralops-query-cache";

export const idbPersister: Persister = {
	persistClient: (client: PersistedClient) => set(CACHE_KEY, client),
	restoreClient: () => get<PersistedClient>(CACHE_KEY),
	removeClient: () => del(CACHE_KEY),
};

export async function clearQueryCache(): Promise<void> {
	await del(CACHE_KEY);
}
